import { GroupModel } from "./group.model";
import { QuestionModel } from "./question.model";
import { SubmissionModel } from "./Submission.model";

export class SurveyModel {
    public surveyId: number = 0;
    
    public name: string = '';

    public titleEn: string = '';
    public titleFr: string = '';
    public title: string = '';
    
    public startNotesEn: string = '';
    public startNotesFr: string = '';
    public startNotes: string = '';
    
    public endNotesEn: string = '';
    public endNotesFr: string = '';
    public endNotes: string = '';
    
    public statusId: number = 0;
    public newStatusId: number = 0;
    
    public startDate: Date = new Date();
    public endDate: Date = new Date();

    public groups: GroupModel[] = [];
    
    public questions: QuestionModel[] = [];

    public submissions: SubmissionModel[] = []; 
}
